/*
 * Holly Palm — aramayı sadece ürün başlığında çalıştırır.
 *
 * Shopify'ın anlamsal (semantic) araması options[fields]=title parametresini yok sayıyor;
 * ama sorgu söz dizimindeki "title:" alan kısıtına uyuyor:
 *   "siyah helena"  →  "title:siyah title:helena"   (her kelime başlıkta geçmeli)
 * Not: "title:" tam kelimeyle eşleşir, yarım kelimede (hel) sonuç vermez. Anlık aramada
 * bu durumda normal öneriler çekilip başlığında yazılan geçenler süzülür (theme.js).
 *
 * <head> içinde yüklenir: arama sayfası, title: içermeyen bir sorguyla açılırsa
 * (eski link, Google vb.) sayfa render edilmeden doğru sorguya yönlendirilir.
 */
(function () {
  var PREFIX = 'title:';

  function clean(value) {
    return String(value || '')
      .replace(/title:/gi, ' ')
      .replace(/[*"():]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function words(value) {
    var cleaned = clean(value);
    return cleaned ? cleaned.split(' ') : [];
  }

  function toQuery(value) {
    return words(value).map(function (w) {
      // AND / OR / NOT büyük harfle operatör sayılır; kelime olarak kalsın
      return PREFIX + w.toLocaleLowerCase('tr');
    }).join(' ');
  }

  function isTitleQuery(value) {
    var ws = String(value || '').trim().split(/\s+/);
    return ws.length > 0 && ws.every(function (w) { return w.toLowerCase().indexOf(PREFIX) === 0; });
  }

  // Türkçe karakterleri sadeleştirip küçük harfe çevirir (gömlek ~ gomlek ~ GÖMLEK)
  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('tr')
      .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i')
      .replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u')
      .normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // Başlığında yazılan her kelime geçen sonuçları bırakır
  function filterByTitle(items, value) {
    var ws = words(value).map(normalize);
    return (items || []).filter(function (item) {
      var title = normalize(item.title);
      return ws.every(function (w) { return title.indexOf(w) > -1; });
    });
  }

  window.hpTitleSearch = {
    clean: clean,
    toQuery: toQuery,
    isTitleQuery: isTitleQuery,
    filterByTitle: filterByTitle
  };

  function isSearchForm(form) {
    var action = form.getAttribute('action') || '';
    return /\/search\/?$/.test(action.split('?')[0]) && form.querySelector('.main-search__input');
  }

  // Arama formu gönderilirken q'yu title: sorgusuna çevir; görünen kutuya dokunma
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !isSearchForm(form)) return;
    var input = form.querySelector('.main-search__input');
    var query = toQuery(input.value);
    if (!query) return;

    var hidden = form.querySelector('input[type="hidden"][data-hp-q]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('data-hp-q', '');
      form.appendChild(hidden);
    }
    hidden.name = 'q';
    hidden.value = query;
    input.removeAttribute('name');
    // geri tuşuyla dönülürse (bfcache) form tekrar normal çalışsın
    setTimeout(function () {
      input.setAttribute('name', 'q');
      hidden.removeAttribute('name');
    }, 0);
  }, true);

  // Arama sayfası title: olmadan açıldıysa doğru sorguya yönlendir
  if (/\/search\/?$/.test(window.location.pathname)) {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (q && !isTitleQuery(q) && toQuery(q)) {
      params.set('q', toQuery(q));
      params.delete('page');
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }
})();
